import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPT: CultureInfo = {
  name: 'en-PT',
  displayName: 'English (Portugal)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PT',
  parent: CultureInfoEn
};
